// extracted by mini-css-extract-plugin
export default {"root":"LoadingModal_root__EXNV9","icon":"LoadingModal_icon__mnJMe","title":"LoadingModal_title__QKkWY","tip":"LoadingModal_tip__qe2PQ"};